import { render } from "./TopHead.vue?vue&type=template&id=3a40496f&scoped=true&ts=true"
import script from "./TopHead.vue?vue&type=script&lang=ts"
export * from "./TopHead.vue?vue&type=script&lang=ts"

import "./TopHead.vue?vue&type=style&index=0&id=3a40496f&lang=less&scoped=true"

import exportComponent from "/builds/toyota/bo/merchant-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a40496f"]])

export default __exports__